module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "color-map"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.colorMap) ? _c('svg-map', {
    attrs: {
      "map": _vm.colorMap,
      "src": ("coloring_" + _vm.door_count + "doors.svg"),
      "bg": (_vm.door_count + "doors.svg")
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "inspection-tab-white"
  }, [_c('div', {
    attrs: {
      "id": "external-elements"
    }
  }, _vm._l((_vm.inspection_externals), function(inspection_external) {
    return (inspection_external.inspection_type == 'MEASURABLE') ? _c('div', {
      staticClass: "row"
    }, [_c('h2', {
      staticClass: "title"
    }, [_vm._v("\n                    " + _vm._s(inspection_external.element.name) + "\n                    "), (inspection_external.plastic_state == '1') ? _c('span', [_vm._v(" (пластиковый)")]) : _vm._e()]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6"
    }, [_c('div', {
      staticClass: "image"
    }, [_c('div', {
      staticClass: "image-points"
    }, [_c('img', {
      attrs: {
        "src": ("" + (inspection_external.element.image_path))
      }
    }), _vm._v(" "), (inspection_external.quality == 'CROSS') ? _c('div', {
      staticClass: "quality"
    }) : _vm._e(), _vm._v(" "), _vm._l((inspection_external.measurable_points), function(measurable_point) {
      return _c('div', {
        staticClass: "point",
        style: (("left: " + (measurable_point.x-12) + "px;top: " + (measurable_point.y-12) + "px"))
      }, [_c('div', {
        staticClass: "marker"
      }), _vm._v(" "), _c('div', {
        staticClass: "marker-label"
      }, [_vm._v(_vm._s(measurable_point.pivot.value))])])
    })], 2)])]), _vm._v(" "), _c('div', {
      staticClass: "col-lg-6 elements-in-section"
    }, [_c('div', {
      staticClass: "title-photo"
    }, [_c('h3', [_vm._v("Повреждения")]), _vm._v(" "), _c('button', {
      staticClass: "btn btn-sm btn-edit",
      on: {
        "click": function($event) {
          inspection_external.photo.display = !inspection_external.photo.display
        }
      }
    }, [_vm._v("Смотреть фото")]), _vm._v(" "), (inspection_external.photo.display) ? _c('div', {
      staticClass: "inspection-photo"
    }, [_c('a', {
      attrs: {
        "href": inspection_external.photo.url,
        "target": "_blank"
      }
    }, [_c('img', {
      attrs: {
        "src": inspection_external.photo.url
      }
    })])]) : _vm._e()]), _vm._v(" "), _c('table', {
      staticClass: "table table-striped"
    }, [_c('tbody', _vm._l((inspection_external.damages), function(damage) {
      return _c('tr', [_c('td', [_vm._v(_vm._s(damage.short_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(damage.name))])])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "car_comment"
    }, [_c('div', {
      staticClass: "comment_body"
    }, [_vm._v(_vm._s(inspection_external.comment))])]), _vm._v(" "), _c('h3', [_vm._v("Немаркированные элементы")]), _vm._v(" "), _c('inspection-external-unmarked', {
      attrs: {
        "inspection_externals": _vm.inspection_externals,
        "section_id": inspection_external.section_id
      }
    })], 1), _vm._v(" "), _c('inspection-external-unmeasurable', {
      attrs: {
        "inspection_externals": _vm.inspection_externals,
        "section_id": inspection_external.section_id
      }
    })], 1) : _vm._e()
  }))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "color-marker-header"
  }, [_c('h2', [_vm._v("Цветовые обозначения")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "color-marker-box color-marker-box-yellow"
  }), _vm._v("\n                Производился"), _c('br'), _vm._v("\n                окрас детали\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "color-marker-box color-marker-box-orange"
  }), _vm._v("\n                Производился окрас"), _c('br'), _vm._v("\n                детали с ремонтом\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "color-marker-box color-marker-box-pink"
  }), _vm._v("\n                Производилась"), _c('br'), _vm._v("\n                замена детали\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-3"
  }, [_c('div', {
    staticClass: "color-marker-box color-marker-box-red"
  }), _vm._v("\n                Производился ремонт несущих"), _c('br'), _vm._v("\n                элементов кузова\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-2"
  }, [_c('div', {
    staticClass: "color-marker-box color-marker-box-blue"
  }), _vm._v("\n                Требуется замена детали\n            ")])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-46a15381", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-46a15381"}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/InspectionExternal.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-46a15381"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/InspectionExternal.vue
// module chunks = 0